import createLucideIcon from '../createLucideIcon';

const ChevronsDown = createLucideIcon('ChevronsDown', [
  ['polyline', { points: '7 13 12 18 17 13', key: 'am1j83' }],
  ['polyline', { points: '7 6 12 11 17 6', key: 'pjsmwq' }],
]);

export default ChevronsDown;
